
import { defineComponent, watch, ref } from "vue";
import runEvn from "@/modular/runEvn/RunEvn";
import { getInteractiveById } from "@/api/NeighborInteractiveApi";//互助咨询
import { getLoveHelpById } from "@/api/NeighborLoveHelpApi";//爱心求助
import { getNeighborActivityById } from "@/api/neighborActivityApi";//活动
import { getHelpUserMessage, postHelpUserMessage } from "@/api/NeighborHelpUserMessage";//留言
import { postActSignUp } from "@/api/NeighborActSignUp";//活动
import { postHelpOrder } from "@/api/NeighborHelpOrder";//
import { useRoute } from "vue-router";
import { Toast as toast } from 'vant';
import { loginOperAsync } from "@/modular/Session";

import { titleInfo } from '@/modular/Title';
import { updateShareData } from "@/modular/Weixinh5";
import { platformInfo } from "@/modular/Platform";
import { getTenanCnf } from '@/modular/TenantCnf/main';





const fileBaseUrl = runEvn().fileBaseUrl;

export default defineComponent({
  setup(props) {
    const route = useRoute();
    // 初始化
    const data = ref({
      id: "",
      content: "",
      title: "",
      headUrl: "",
      userName: "",
      createTimeStamp: new Date(1666007599403),
      watchCount: 0,
      loveHelpPublishType: 0,
      contactUser: "",
      phone: "",
      targetAddress: "",
      helpStatus: 0,
      isMy: false,
      neighborActivityStatus: 0,
      actHostUser: 0,
      startActTime: 0,
      endActTime: 0,
      isSignUp: false,
      payPoint: 0,
      province: "",
      city: "",
      district: "",
      address: "",
    });
    let dataHelpUserMessage = ref([
      {
        id: "",
        headUrl: "",
        userName: "",
        isSignUp: false,
        messageTime: "",
        content: "",
        postReply: {
          headUrl: "",
          userName: "",
          messageTime: "",
          content: "",
        },
      },
    ]);
    let pageNum = 1;
    let isNoMoreMessage = ref(false);
    let commentPlaceholder = "我来说两句..";
    let helpActType = ref(0);
    let comment = ref({
      showPopup: false,
      placeholder: commentPlaceholder,
      id: "",
      value: "",
    });
    let commentForm = ref({
      userId: "",
      linkId: "",
      messageTime: 0,
      helpActType: 0,
      parentId: "",
      content: ""
    });
    const enroll = ref({
      showPopup: false,
      placeholder: "请输入您的留言",
      form: {
        userName: "",
        phone: "",
        memo: "",
        signUpTime: 0,
        activityId: "",

        helpId: "",
        helpOrderStatus: 0,
        cancelReason: "",
        loveHelpPublishType: 0,
      },
    });
    const freeBack = ref({
      showPopup: false,
      placeholder: "请输入反馈信息",
      form: {
        id: "",
        feedback: "",
      },
    });
    watch(
      () => props.id,
      () => {
        reset();
        loadData();
      }
    );
    const reset = () => {
      pageNum = 1;
      isNoMoreMessage.value = false;
    };

    const loadData = async () => {

      helpActType.value = Number(Array.isArray(route.query.helpActType) ? route.query.helpActType[0] : route.query.helpActType);

      if (helpActType.value == 1) {
        await methods.getInteractive();
      }
      if (helpActType.value == 2) {
        await methods.getLoveHelp();

      } if (helpActType.value == 3) {
        await methods.getActivity();
      }
      await methods.getMessage();


    };
    //方法
    const methods = {
      img(key: string) {
        return fileBaseUrl + key;
      },
      async showComment(data: any, name: string, id: string) {
        await loginOperAsync();
        comment.value.showPopup = true
        if (data) {
          comment.value.placeholder = "回复：@" + name;
          comment.value.id = id;
        } else {

          comment.value.placeholder = commentPlaceholder;
          comment.value.id = "";
        }
      },
      async submitHelpUserMessage() {

        if (comment.value.value.trim().length == 0) {
          comment.value.value = "";
          toast.fail("请输入留言。");
          return;
        }

        commentForm.value.linkId = props.id as string;
        commentForm.value.messageTime = new Date().getTime();
        commentForm.value.helpActType = Number(helpActType.value);
        commentForm.value.parentId = comment.value.id;
        commentForm.value.content = comment.value.value;

        let isok = await postHelpUserMessage(commentForm.value);
        if (isok) {
          toast.success(`留言发表成功，待审核通过后展示。`);

          comment.value.showPopup = false;
          comment.value.placeholder = commentPlaceholder;
          comment.value.id = "";
          comment.value.value = "";

          pageNum = 1;
          methods.getMessage();

        }
      },
      async submitActSignUp() {

        let mobile = /^1[0-9][0-9]\d{8}$/;
        let errorMessage = "";
        if (enroll.value.form.userName.trim().length == 0) {
          errorMessage = "请输入姓名";
        }
        if (!mobile.test(enroll.value.form.phone)) {
          errorMessage = "请填写正确的手机号码";
        }
        if (errorMessage != "") {
          toast.fail(errorMessage);
          return;
        }
        if (helpActType.value == 3) {
          enroll.value.form.signUpTime = new Date().getTime();
          enroll.value.form.activityId = data.value.id;
          var isokActSignUp = await postActSignUp(enroll.value.form);
          if (isokActSignUp) {
            toast.success(`报名成功`);
            enroll.value.showPopup = false;
            this.loadData();

          } else {
            toast.fail('报名失败');
          }
        }
        if (helpActType.value == 2) {
          enroll.value.form.signUpTime = new Date().getTime();
          enroll.value.form.helpId = data.value.id;
          enroll.value.form.helpOrderStatus = 1;
          enroll.value.form.cancelReason = "";
          enroll.value.form.loveHelpPublishType = 0;


          var isokLoveHelp = await postHelpOrder(enroll.value.form);
          if (isokLoveHelp) {
            toast.success(`接单成功`);
            enroll.value.showPopup = false;
            this.loadData();
          } else {
            toast.fail('接单失败');
          }
        }

      },
      async submitFreeback() {
        if (freeBack.value.form.feedback.trim().length == 0) {
          toast.fail('请输入反馈信息');
          return;
        }
        freeBack.value.form.id = data.value.id;
        var isokFreeback = await postHelpOrder(freeBack.value.form);
        if (isokFreeback) {
          toast.success(`反馈成功`);
          freeBack.value.showPopup = false;
        } else {
          toast.fail('反馈失败');
        }
      }
      ,
      showMoreMessage() {

        methods.getMessage();

      },
      format(time: string | number | Date, string: string) {
        return new Date(time).format(string);
      },
      async getInteractive() {
        const response: any = (await getInteractiveById(props.id as string)) || { rows: [], };
        data.value = response;
      },
      async getActivity() {
        const response: any = (await getNeighborActivityById(props.id)) || { rows: [], };
        data.value = response;
      },
      async getLoveHelp() {
        const response: any = (await getLoveHelpById(props.id)) || { rows: [], };
        data.value = response;
      },
      async getMessage() {
        let params = {
          pageNum: pageNum,
          pageSize: 4,
          linkId: props.id,
        };

        const response: any = (await getHelpUserMessage(params)) || { rows: [], };


        if (pageNum == 1) {
          dataHelpUserMessage.value = response.rows;

        } else {
          for (let index = 0; index < response.rows.length; index++) {
            dataHelpUserMessage.value.push(response.rows[0]);

          }
        }
        //当返回数量和本地数量一样 就隐藏更多按钮
        if (dataHelpUserMessage.value.length == response.total) {
          isNoMoreMessage.value = true;
        }

        pageNum++;

      },

      formatImgUrl() {
        const headUrl = data.value.headUrl;
        if (headUrl) {
          return fileBaseUrl + headUrl;
        }
        const tenantInfo = getTenanCnf();
        return tenantInfo.logoSrc;
      },

      // 设置微信分享
      async setWxShare() {
        // const runEvnData = runEvn();
        const _titleInfo = data.value.title;
        // const imgUrl = this.img(this.imgs[0]);
        const shareData = {
          title: `${_titleInfo}`,
          desc: `${data.value.content}`,
          link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: methods.formatImgUrl(), // 分享图标
        };
        await updateShareData(shareData);
      },
    };

    return {
      loadData, data, dataHelpUserMessage, enroll, freeBack,
      ...methods, helpActType, comment, isNoMoreMessage
    };
  },
  data() {
    return {

    }
  },
  mounted() {
    this.loadData().then(() => {
      this.setWxShare();
    });
  },
  methods: {

  },
  props: {
    id: {
      type: String,
    },
  },
});

